document.querySelectorAll('.yrp-header-search').forEach(function(search){
  if(search.dataset.bound)return;
  search.dataset.bound='true';
  var trigger=search.querySelector(':scope>summary');
  var input=search.querySelector('input[type=search]');
  var timer;
  var pointer=window.matchMedia('(hover:hover) and (min-width:1200px)');
  var close=function(){clearTimeout(timer);search.open=false;trigger.setAttribute('aria-expanded','false');};
  search.addEventListener('mouseenter',function(){if(pointer.matches){clearTimeout(timer);search.open=true;}});
  search.addEventListener('mouseleave',function(){if(pointer.matches){clearTimeout(timer);timer=setTimeout(close,160);}});
  pointer.addEventListener('change',close);
  search.addEventListener('toggle',function(){
    trigger.setAttribute('aria-expanded',String(search.open));
    if(search.open){
      var header=search.closest('.yrp-banner-header,.header');
      if(header)header.querySelectorAll('.yrp-header-links__item[open],.yrp-site-nav[open]').forEach(function(menu){menu.open=false;});
      input.focus();
    }
  });
  search.querySelector('[data-search-close]').addEventListener('click',function(){close();trigger.focus();});
  search.addEventListener('keydown',function(event){if(event.key==='Escape'){close();trigger.focus();}});
  document.addEventListener('click',function(event){if(!search.contains(event.target))close();});
});
